"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _layouts = require("@seedlang/layouts");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _overlay_ui = _interopRequireDefault(require("./overlay_ui"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ChatUI = (_class = /*#__PURE__*/function (_RootState) {
  function ChatUI() {
    var _this;
    _classCallCheck(this, ChatUI);
    _this = _callSuper(this, ChatUI);
    _initializerDefineProperty(_this, "chatId", _descriptor, _this);
    _this.userStore = _stores.UserStore;
    _this.authUserStore = _stores.AuthUserStore;
    _this.mediaStore = _stores.MediaStore;
    _this.userInputStore = new _stores.UserInputStore(_this.mediaStore);
    _this.chatStore = _stores.ChatStore;
    _this.chatMessageStore = _stores.ChatMessageStore;
    _this.commentStore = _stores.CommentStore;
    _this.feedbackStore = _stores.FeedbackStore;
    _this.layout = new _layouts.ChatLayout(_this);
    _this.userChatAssociationStore = _stores.UserChatAssociationStore;
    return _this;
  }
  _inherits(ChatUI, _RootState);
  return _createClass(ChatUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "chat",
    get: function get() {
      return this.chatStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "chatCreatedByMe",
    get: function get() {
      return (0, _utils.isPresent)(this.chat) && (0, _utils.isPresent)(this.user) && this.chat.chatCreatorId === this.user.id;
    }

    // CHAT INTERACTIONS
  }, {
    key: "onCreateComment",
    value: function onCreateComment(chatMessageId, text, commentType, xp, xpSlug, callback) {
      this.commentStore.create({
        data: {
          comment_type: commentType,
          commentable_id: chatMessageId,
          commentable_type: 'ChatMessage',
          text: text,
          xp: xp,
          xp_slug: xpSlug
        }
      }, callback || this.reloadShow.bind(this));
    }
  }, {
    key: "reloadShow",
    value: function reloadShow() {
      this.chatStore.reloadShow();
    }
  }, {
    key: "reloadIndex",
    value: function reloadIndex() {
      this.chatStore.reloadIndex();
    }
  }, {
    key: "clearCurrentChat",
    value: function clearCurrentChat() {
      this.chatStore.clearShowData();
      this.mediaStore.onReset();
      this.clearChatInterval();
    }

    // USER INDEX
  }, {
    key: "initiateChatPoll",
    value: function initiateChatPoll(chatId) {
      var _this2 = this;
      if (chatId) {
        this.chatStore.getShow({
          ids: {
            chatId: chatId
          }
        });
        this.clearChatInterval();
        this.interval = setInterval(function () {
          _this2.chatStore.getShow({
            ids: {
              chatId: chatId
            }
          });
        }, 15000);
      }
    }
  }, {
    key: "clearChatInterval",
    value: function clearChatInterval() {
      clearInterval(this.interval);
    }
  }, {
    key: "loadChatIndex",
    value: function loadChatIndex() {
      this.chatStore.getIndex({}, this.afterGetIndex);
    }
  }, {
    key: "loadChatIndexAndForward",
    value: function loadChatIndexAndForward() {
      this.chatStore.getIndex({}, this.afterGetIndexAndForward);
    }

    // CRUD
  }, {
    key: "onDestroyChatMessage",
    value: function onDestroyChatMessage(chatMessageId) {
      this.chatMessageStore.destroy({
        ids: {
          chatMessageId: chatMessageId
        }
      }, this.reloadShow.bind(this));
    }
  }, {
    key: "onDestroyChat",
    value: function onDestroyChat() {
      this.chatStore.destroy({
        ids: {
          chatId: this.chat.id
        }
      }, this.afterDestroyChat.bind(this));
    }
  }, {
    key: "onLeaveChat",
    value: function onLeaveChat() {
      this.userChatAssociationStore.destroy({
        ids: {
          id: this.chat.id
        }
      }, this.afterDestroyChat.bind(this));
    }
  }, {
    key: "afterDestroyChat",
    value: function afterDestroyChat() {
      this.loadChatIndexAndForward();
      this.clearOverlays();
    }
  }, {
    key: "onAfterUpdateChat",
    value: function onAfterUpdateChat() {
      this.chatStore.getIndex({}, this.afterGetIndex);
      this.loadChat();
    }
  }, {
    key: "loadChat",
    value: function loadChat() {
      this.chatStore.getShow({
        ids: {
          chatId: this.chat.id
        }
      });
    }
  }, {
    key: "clearOverlays",
    value: function clearOverlays() {
      _overlay_ui["default"].removeOverlays(['chatEdit', 'chatShow', 'chatCreatorEdit']);
    }
  }, {
    key: "afterGetIndex",
    value: function afterGetIndex(resp) {
      this.chatStore.setIndexData(resp);
    }
  }, {
    key: "afterGetIndexAndForward",
    value: function afterGetIndexAndForward(resp) {
      this.chatStore.setIndexData(resp);
      this.routeToFirstChat();
    }
  }, {
    key: "routeToFirstChat",
    value: function routeToFirstChat() {
      if (!this.layout.isMobile && !this.chatId && !this.createChat && this.chatStore.hasIndexData) {
        _stores.RouteStore.routeToNamed('chats.show', {
          chatId: this.chatStore.indexData[0].id
        });
      }
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "chatId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "chat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chatCreatedByMe", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "chatCreatedByMe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreateComment", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCreateComment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadShow", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadShow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadIndex", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearCurrentChat", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearCurrentChat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initiateChatPoll", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initiateChatPoll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadChatIndex", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadChatIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadChatIndexAndForward", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadChatIndexAndForward"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDestroyChatMessage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDestroyChatMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDestroyChat", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDestroyChat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onLeaveChat", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onLeaveChat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterDestroyChat", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterDestroyChat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAfterUpdateChat", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onAfterUpdateChat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadChat", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadChat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetIndex", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetIndexAndForward", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetIndexAndForward"), _class.prototype), _class);
var _default = exports["default"] = new ChatUI();